﻿; (function ($) {
	"use strict";

	$.fn.passwordToggle = function () {
		var passwordFieldId = this.attr('data-toggleFor');
		this.click(function () {
			if ($(this).attr('data-passwordIsMasked') === 'true') {
				$('#' + passwordFieldId).prop('type', 'text');
				$(this).text($(this).attr('data-unmaskText'));
				$(this).attr('data-passwordIsMasked', 'false');
			} else {
				$('#' + passwordFieldId).prop('type', 'password');
				$(this).text($(this).attr('data-maskText'));
				$(this).attr('data-passwordIsMasked', 'true');
			}
			//$('#' + passwordFieldId).focus();
		});
	};

}(jQuery));

